var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "wrap" }, [
    _c("header", { staticClass: "header header--intro" }, [
      _c("div", { staticClass: "header__container" }, [
        _c("div", { staticClass: "header__row" }, [
          _c("div", { staticClass: "logo" }, [
            _c("div", { staticClass: "logo__container" }, [
              _c("div", { staticClass: "logo__row" }, [
                _c("h1", {
                  staticClass: "logo__logo",
                  class: { "logo__logo logo__logo--black": this.isPopup },
                  attrs: { "aria-label": "my Protein TEST" }
                }),
                _vm._v(" "),
                _c("button", {
                  staticClass: "logo__trigger",
                  class: { "rotate-down": this.isPopup },
                  attrs: {
                    type: "button",
                    "aria-controls": "logoLayer",
                    "aria-label": "버튼",
                    "aria-haspopup": "true",
                    "aria-expanded": "false"
                  },
                  on: {
                    click: function($event) {
                      return _vm.popup()
                    }
                  }
                }),
                _vm._v(" "),
                this.isPopup
                  ? _c(
                      "div",
                      {
                        staticClass: "logo__layer",
                        style: { display: this.isPopup ? "block" : "none" },
                        attrs: { role: "menu", id: "logoLayer" }
                      },
                      [
                        _c("a", {
                          staticStyle: { cursor: "pointer" },
                          attrs: { role: "menuitem", "aria-label": "Amway" },
                          on: {
                            click: function($event) {
                              return _vm.moveAmwayPage()
                            }
                          }
                        })
                      ]
                    )
                  : _vm._e()
              ])
            ])
          ]),
          _vm._v(" "),
          _c("button", {
            staticClass: "share",
            attrs: {
              type: "button",
              "aria-haspopup": "dialog",
              "aria-label": "공유",
              "data-micromodal-trigger": "shareSns"
            }
          })
        ])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "contents" }, [
      _c(
        "div",
        { staticClass: "contents__contents contents__contents--intro" },
        [
          _c("div", { staticClass: "intro-swiper" }, [
            _c(
              "div",
              { staticClass: "intro-swiper__swiper swiper-container" },
              [
                _c("div", { staticClass: "swiper-wrapper" }, [
                  _c(
                    "div",
                    {
                      staticClass:
                        "intro-swiper__slide intro-swiper__slide--first swiper-slide"
                    },
                    [
                      _vm._m(0),
                      _vm._v(" "),
                      _vm._m(1),
                      _vm._v(" "),
                      _c(
                        "div",
                        [
                          this.swiperIndex < 3
                            ? _c("vLottiePlayer", {
                                staticStyle: { width: "100%", height: "100%" },
                                attrs: {
                                  animationData: require("./assets/lottie/intro01.json"),
                                  background: "transparent",
                                  speed: "1",
                                  loop: "",
                                  autoplay: ""
                                }
                              })
                            : _vm._e()
                        ],
                        1
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "intro-swiper__slide intro-swiper__slide--second swiper-slide"
                    },
                    [
                      _vm._m(2),
                      _vm._v(" "),
                      _vm._m(3),
                      _vm._v(" "),
                      _c(
                        "div",
                        [
                          _c("vLottiePlayer", {
                            staticStyle: { width: "100%", height: "100%" },
                            attrs: {
                              animationData: require("./assets/lottie/intro02.json"),
                              background: "transparent",
                              speed: "1",
                              loop: "",
                              autoplay: ""
                            }
                          })
                        ],
                        1
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "intro-swiper__slide intro-swiper__slide--third swiper-slide"
                    },
                    [
                      _vm._m(4),
                      _vm._v(" "),
                      _vm._m(5),
                      _vm._v(" "),
                      _c(
                        "div",
                        [
                          _c("vLottiePlayer", {
                            staticStyle: { width: "100%", height: "100%" },
                            attrs: {
                              animationData: require("./assets/lottie/intro03.json"),
                              background: "transparent",
                              speed: "1",
                              loop: "",
                              autoplay: ""
                            }
                          })
                        ],
                        1
                      )
                    ]
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "swiper-pagination" }),
                _vm._v(" "),
                _c("div", { staticClass: "swiper-button-prev" }),
                _vm._v(" "),
                _c("div", { staticClass: "swiper-button-next" })
              ]
            )
          ]),
          _vm._v(" "),
          _vm._m(6)
        ]
      )
    ]),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "modal",
        attrs: { id: "shareSns", "aria-hidden": "true" }
      },
      [
        _c(
          "div",
          {
            staticClass: "modal__overlay",
            attrs: { tabindex: "-1", "data-micromodal-close": "shareSns" }
          },
          [
            _c(
              "div",
              {
                staticClass: "modal__body",
                attrs: {
                  role: "dialog",
                  "aria-modal": "true",
                  "aria-labelledby": "shareSnsTitle"
                }
              },
              [
                _vm._m(7),
                _vm._v(" "),
                _c("div", { staticClass: "modal__contents" }, [
                  _c("div", { staticClass: "sns-list" }, [
                    _c("div", { staticClass: "sns-list__list" }, [
                      _c(
                        "a",
                        {
                          staticClass:
                            "sns-list__item sns-list__item--kakaoTalk",
                          attrs: { href: "#;", id: "kakao-btn" },
                          on: {
                            click: function($event) {
                              return _vm.shareSns("kakaoTalk")
                            }
                          }
                        },
                        [_c("i"), _vm._v(" "), _c("p", [_vm._v("카카오톡")])]
                      ),
                      _vm._v(" "),
                      _c(
                        "a",
                        {
                          staticClass:
                            "sns-list__item sns-list__item--kakaostory",
                          attrs: { href: "#" },
                          on: {
                            click: function($event) {
                              return _vm.shareSns("kakaostory")
                            }
                          }
                        },
                        [
                          _c("i"),
                          _vm._v(" "),
                          _c("p", [_vm._v("카카오스토리")])
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "a",
                        {
                          staticClass:
                            "sns-list__item sns-list__item--facebook",
                          attrs: { href: "#" },
                          on: {
                            click: function($event) {
                              return _vm.shareSns("facebook")
                            }
                          }
                        },
                        [_c("i"), _vm._v(" "), _c("p", [_vm._v("페이스북")])]
                      ),
                      _vm._v(" "),
                      _c(
                        "a",
                        {
                          staticClass: "sns-list__item sns-list__item--twitter",
                          attrs: { href: "#" },
                          on: {
                            click: function($event) {
                              return _vm.shareSns("twitter")
                            }
                          }
                        },
                        [_c("i"), _vm._v(" "), _c("p", [_vm._v("트위터")])]
                      ),
                      _vm._v(" "),
                      _c(
                        "a",
                        {
                          staticClass: "sns-list__item sns-list__item--band",
                          attrs: { href: "#" },
                          on: {
                            click: function($event) {
                              return _vm.shareSns("naverBand")
                            }
                          }
                        },
                        [_c("i"), _vm._v(" "), _c("p", [_vm._v("밴드")])]
                      ),
                      _vm._v(" "),
                      _c(
                        "a",
                        {
                          staticClass: "sns-list__item sns-list__item--copy",
                          attrs: { href: "#" },
                          on: {
                            click: function($event) {
                              return _vm.copyEventURL("currentURL")
                            }
                          }
                        },
                        [_c("i"), _vm._v(" "), _c("p", [_vm._v("URL 복사")])]
                      )
                    ]),
                    _vm._v(" "),
                    _vm._m(8)
                  ])
                ])
              ]
            )
          ]
        )
      ]
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "title" }, [
      _vm._v("\n                                내가 바로"),
      _c("br"),
      _vm._v(
        "\n                                단백질 전문가\n                            "
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "desc" }, [
      _vm._v(
        "\n                                백세 건강을 위해 내 몸에 꼭 필요한 단백질,"
      ),
      _c("br"),
      _vm._v("\n                                어디까지 알고 계신가요?"),
      _c("br"),
      _vm._v(
        "\n                                단백질에 대한 모든 것을 알려 드릴게요!\n                            "
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "title" }, [
      _vm._v("\n                                스스로 알아보는"),
      _c("br"),
      _vm._v(
        "\n                                단백질 부족 신호\n                            "
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "desc" }, [
      _vm._v("\n                                단백질이 부족하면 우리 몸은"),
      _c("br"),
      _vm._v(
        "\n                                ‘위험 신호’를 보냅니다. 이런 증상이 있다면"
      ),
      _c("br"),
      _vm._v(
        "\n                                단백질 꼭 챙겨 드셔야 해요.\n                            "
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "title" }, [
      _vm._v("\n                                내 몸이 필요로 하는"),
      _c("br"),
      _vm._v(
        "\n                                하루 단백질량은?\n                            "
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "desc" }, [
      _vm._v(
        "\n                                단백질은 근육을 이루는 주요 구성 성분으로,"
      ),
      _c("br"),
      _vm._v(
        "\n                                근육을 만드는 필수 재료예요! 효율적인"
      ),
      _c("br"),
      _vm._v(
        "\n                                근육 증가를 위해 충분히 단백질을 섭취해주세요."
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "button" }, [
      _c("div", { staticClass: "button__row" }, [
        _c(
          "a",
          {
            staticClass: "button__item button__item--secondary",
            attrs: { href: "/quiz" }
          },
          [_vm._v("시작하기")]
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("header", { staticClass: "modal__header" }, [
      _c("p", { staticClass: "modal__title", attrs: { id: "shareSnsTitle" } }, [
        _vm._v("SNS 공유")
      ]),
      _vm._v(" "),
      _c("button", {
        staticClass: "close",
        attrs: {
          type: "button",
          "aria-label": "닫기",
          "data-micromodal-close": "shareSns"
        }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "sns-list__noti" }, [
      _c("em", [_vm._v("SNS 공유안내")]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n                                한국암웨이의 amway.co.kr에서 서비스 되는 일체의 콘텐츠에 대한 지적 재산권은 한국암웨이㈜에 있으며, 임의로 자료를 수정/변경하여 사용하거나, 기타 개인의 영리 목적으로 사용할 경우에는 지적 재산권 침해에 해당하는 사안으로, 그 모든 법적 책임은 콘텐츠를 불법으로 남용한 개인 또는 단체에 있습니다.\n                                "
        ),
        _c("br"),
        _c("br"),
        _vm._v(
          "\n                                모든 자료는 원저작자의 요청이나 한국암웨이의 사정에 따라 예고 없이 삭제될 수 있습니다.\n                            "
        )
      ])
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-9c758c36", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9c758c36","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/myprotein-test/index.vue
// module id = null
// module chunks = 